import { render, staticRenderFns } from "./Restamp.vue?vue&type=template&id=99b1e7a4&scoped=true"
import script from "./Restamp.vue?vue&type=script&lang=js"
export * from "./Restamp.vue?vue&type=script&lang=js"
import style0 from "./Restamp.vue?vue&type=style&index=0&id=99b1e7a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b1e7a4",
  null
  
)

export default component.exports